import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getCarById, updateCar, getWorkOrders } from "../../../components/http";
import CarInfo from "./CarInfo";
import ClientInfo from "./ClientInfo";
import WorkOrderHistory from "./WorkOrderHistory";
import style from "./CarDetail.module.scss";
import HeaderInfo from "../../../components/header/headerInfo";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "../../../components/PopUps/ConfirmDeleteButton";
import { deleteCar } from "../../../components/http";
const CarDetail = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { car_id } = useParams();
  const [car, setCar] = useState(null);
  const [initialCar, setInitialCar] = useState(null);
  const [workOrders, setWorkOrders] = useState([]);
  const [isEditing, setIsEditing] = useState(false);

  const fetchCar = async () => {
    try {
      const fetchedCar = await getCarById(car_id);
      setCar(fetchedCar);
      setInitialCar(fetchedCar);
    } catch (error) {
      console.error("Ошибка загрузки авто:", error);
    }
  };

  const fetchWorkOrders = async () => {
    try {
      const fetchedOrders = await getWorkOrders({
        car_id,
        limit: 100,
        offset: 0,
      });
      setWorkOrders(fetchedOrders.data);
    } catch (error) {
      console.error("Ошибка загрузки заказ-нарядов:", error);
    }
  };

  useEffect(() => {
    fetchCar();
    fetchWorkOrders();
  }, [car_id]);

  const handleEditClick = () => setIsEditing(!isEditing);

  const handleSave = async () => {
    if (!car || !initialCar) return;

    try {
      const changedFields = {};
      Object.keys(car).forEach((key) => {
        if (car[key] !== initialCar[key]) {
          changedFields[key] = key === "client" && car.client ? car.client.id : car[key];
        }
      });

      if (Object.keys(changedFields).length === 0) {
        alert("Нет изменений для сохранения");
        return;
      }

      await updateCar({ car_id: car.id, values: changedFields });
      setIsEditing(false);
      alert("Данные успешно обновлены!");
    } catch (error) {
      console.error("Ошибка обновления авто:", error);
      alert("Ошибка при сохранении данных.");
    }
  };
  const handleDeleteCar = async (id) => {
    await ConfirmationModal({
      title:  t("car.PopUp.delete"),
      text: t("car.PopUp.deleteConfirm"),
      confirmButtonColor: "#d33",
      confirmButtonText:t("Yes"),
      cancelButtonText:t("No"),
      cancelButtonColor: "#3085d6",
      onConfirm: async () => {
        try {
          await deleteCar(id);
          navigate(-1)
        } catch (error) {
          console.error("Ошибка удаления клиента:", error);
        }
      },
      onCancel: () => {
      },
      successTitle: t("car.PopUp.deleted"),
      successText: t("car.PopUp.deleteSucces")
    });
  };
  if (!car) return <div>Загрузка информации...</div>;

  return (
    <>
      <HeaderInfo onEditClick={handleEditClick} title={("car.car.title")} onDelete={()=>handleDeleteCar(car.id)}/>
      

        <div className={style.container}>
          

          <div className={style.detailInfo}>
          
          <CarInfo car={car} isEditing={isEditing} onCarChange={setCar} />
          <WorkOrderHistory workOrders={workOrders} />

          </div>
          <ClientInfo
            car={car}
            isEditing={isEditing}
            onClientChange={(clientId) =>
              setCar((prev) => ({
                ...prev,
                client: { ...prev.client, id: clientId },
              }))
            }
          />
        </div>


      {isEditing && (
        <button className={style.saveButton} onClick={handleSave}>
          Сохранить изменения
        </button>
      )}
    </>
  );
};

export default CarDetail;
